import styled from "styled-components";

export const CheckIcon = styled.span`
  font-size: 16px;
`;

export const ContentList = styled.ul`
  margin-top: 5px;
  padding-left: 20px;
`;
